<template>
  <div>
    <navbar/>
    <transition name="fade-transform" mode="out-in">
      <router-view />
    </transition>
    <foot/>
  </div>
</template>
<script>
import Navbar from './navbar/index'
import foot from './foot/index'

export default {
  name: 'Layout',
  components: { Navbar, foot }
}
</script>
